<template>
  <v-main style="background-color: rgba(239, 249, 253, 1)">
    <!-- おしらせ一覧 -->
    <v-container fluid class="pt-4 pt-lg-4 pt-xl-8" style="background-color: white">
      <v-row no-gutters justify="start" class="mx-8">
        <div class="text-h5 text-xl-h5 text-lg-h6 indigo--text font-weight-bold">最新のおしらせ</div>
      </v-row>
      <v-row no-gutters justify="center" class="mx-auto" v-if="latestNotifications.length > 0" v-resize="onResize">
        <v-col v-for="(item, index) in latestNotifications" :key="index">
          <notification-list-item :item="item" :width="notificationListItemWidth"
                                  :height="notificationListItemHeight"/>
        </v-col>
      </v-row>

      <v-row justify="center" align-content="center" class="mb-1">
        <v-hover v-slot="{ hover }">
          <v-btn
            rounded
            large
            :outlined="!hover"
            :color="hover ? 'rgba(55,119,228,1)' : 'indigo'"
            class="rounded-pill"
            width="15%"
            :to="{name: 'notificationList'}"
            :dark="hover"

          >
            <v-icon left small class="ml-4 ml-xl-8">mdi-format-list-bulleted</v-icon>
            <v-spacer/>
            <span class="font-weight-bold text-body-2 text-lg-body-2 text-xl-h6">おしらせ一覧</span>
            <v-spacer/>
            <v-spacer/>
          </v-btn>
        </v-hover>
      </v-row>
    </v-container>

    <!-- 各種ボタン表示 -->
    <v-container fluid>
      <v-sheet color="backgroundBlueColor" class="py-2">
        <v-row dense justify="space-between" align-content="center" class="mx-auto px-4">
          <v-col v-for="(setting, settingIndex) in buttonSettings" :key="settingIndex">
            <v-sheet
              color="white"
              class="rounded-xl py-4 py-lg-4 py-xl-10 px-4 fill-height"
              style="width: 100%;">
              <v-row no-gutters justify="start" align-content="center" class="mb-xl-8 mb-lg-4 ml-6">
                <div class="text-h6 text-lg-h6 text-xl-h5 indigo--text font-weight-bold">{{ setting.title }}</div>
              </v-row>
              <v-row justify="center" align-content="center" class="mb-4" v-for="(item, index) in setting.buttons"
                     :key="index">
                <v-hover v-slot="{ hover }">
                  <v-btn
                    rounded
                    :outlined="!hover"
                    x-large
                    :color="hover ? 'rgba(55,119,228,1)' : 'indigo'"
                    :dark="hover"
                    class="rounded-pill"
                    :height="buttonHeight"
                    width="85%"
                    :to=item.to
                  >
                    <v-icon left x-large class="ml-8 ml-xl-16">{{ item.icon }}</v-icon>
                    <v-spacer/>
                    <span class="font-weight-bold text-body-2 text-lg-body-2 text-xl-h6"
                          v-html="item.text"></span>
                    <v-spacer/>
                    <v-spacer/>
                  </v-btn>
                </v-hover>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-sheet>
      <v-spacer/>
    </v-container>
  </v-main>
</template>

<script>
import { Logger } from 'aws-amplify';
import moment from 'moment/moment';
import { mapActions, mapGetters } from 'vuex';
import NotificationListItem from '@/components/NotificationListItem';

const logger = new Logger('home');

// おしらせ一覧の表示数
const NOTIFICATION_LIST_NUM = 5;

export default {
  name: 'HomeView',
  components: {
    'notification-list-item': NotificationListItem,
  },

  async created() {
    logger.info('created');

    // おしらせが未取得の場合のみ取得する
    // 必要数で比較するのは、おしらせ詳細にダイレクトでアクセスした場合に、1件のみのケースがあるため
    if (this.notifications.length < NOTIFICATION_LIST_NUM) {
      await this.getNotifications({
        count: NOTIFICATION_LIST_NUM,
        year: moment().format('YYYY'),
      });
    }
  },

  mounted() {
    logger.info('mounted');
    this.onResize();
  },

  data() {
    return {
      // 最新のおしらせの要素サイズ
      notificationListItemWidth: 0,
      notificationListItemHeight: 0,

      // 各種ボタン設定
      buttonSettings: [
        {
          title: '申請 / マニュアル',
          buttons: [
            {
              text: '申請書・マニュアル',
              to: { name: 'manual' },
              icon: 'mdi-book-open-variant',
            },
            {
              text: 'UI/UX',
              to: { name: 'uiUx' },
              icon: 'mdi-alpha-u-box',
            },
            {
              text: 'MOTPhone設定更新方法',
              to: { name: 'motPhone' },
              icon: 'mdi-phone-log',
            },
            {
              text: '制度・福利厚生',
              to: { name: 'welfareList' },
              icon: 'mdi-gift',
            },
          ],
        },
        {
          title: '連絡先',
          buttons: [
            {
              text: 'レポートライン一覧<br>（ニックネーム）',
              to: { name: 'telephoneLine' },
              icon: 'mdi-account-details',
            },
            {
              text: 'MOTPhone 内線・外線一覧',
              to: { name: 'telephoneOutline' },
              icon: 'mdi-deskphone',
            },
            {
              text: '社用携帯電話番号一覧',
              to: { name: 'cellPhoneList' },
              icon: 'mdi-cellphone-text',
            },
            {
              text: '緊急連絡体制',
              to: { name: 'emergencyContact' },
              icon: 'mdi-alert-octagon',
            },
          ],
        },
        {
          title: 'ルール',
          buttons: [
            {
              text: '行動指針',
              to: { name: 'guidelinesForAction' },
              icon: 'mdi-target',
            },
            {
              text: '規程',
              to: { name: 'regulation' },
              icon: 'mdi-thumb-up',
            },
            {
              text: '社用携帯に関するお知らせ',
              to: { name: 'cellPhone' },
              icon: 'mdi-cellphone-cog',
            },
            {
              text: 'オフィス内設備',
              to: { name: 'rule' },
              icon: 'mdi-office-building-cog',
            },
            {
              text: '会社携帯の盗難・紛失時',
              to: { name: 'phoneLost' },
              icon: 'mdi-block-helper',
            },
          ],
        },
      ],
    };
  },

  computed: {
    /**
     * 解像度でボタンサイズを調整する
     */
    buttonHeight() {
      return this.isFullHD() ? '86.5px' : '50px';
    },

    /**
     * 最新のおしらせ
     */
    latestNotifications() {
      return this.notifications.slice(0, NOTIFICATION_LIST_NUM);
    },

    ...mapGetters(['notifications']),
  },

  methods: {
    /**
     * フルHD（以上）判定
     * 社内での端末の普及割合で、HDorフルHDで見え方を調整している
     */
    isFullHD() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl':
          return true;
        default:
          return false;
      }
    },

    /**
     * リサイズ処理
     */
    onResize() {
      [this.notificationListItemWidth, this.notificationListItemHeight] = this.calcNotificationItemSize();
    },

    /**
     * おしらせ一覧要素の表示サイズを計算する
     */
    calcNotificationItemSize() {
      const w = window.innerWidth;
      const margin = 15;
      const width = (w - margin * (NOTIFICATION_LIST_NUM + 1)) / NOTIFICATION_LIST_NUM;

      const h = window.innerHeight;
      const height = h * 0.3;

      return [
        width,
        height,
      ];
    },

    ...mapActions(['getNotifications']),
  },
};
</script>

<style scoped lang="scss">
</style>
